var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 52,
    viewBox: "0 0 92 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 91,
    height: 51,
    rx: 25.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 91,
    height: 51,
    rx: 25.5,
    stroke: "#0B8E70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3453 19.8945V21.6328H14.693V19.8945H17.9742V17.5898H20.1227V19.8945H23.3453ZM15.2008 26.6719C15.1813 24.2695 16.8121 22.5605 19.0484 22.5703C21.2945 22.5605 22.8961 24.2695 22.8961 26.6719C22.8961 29.123 21.2945 30.832 19.0484 30.832C16.8121 30.832 15.1813 29.123 15.2008 26.6719ZM17.1148 26.6719C17.1051 28.0977 17.9059 28.9863 19.0484 28.9766C20.1813 28.9863 20.982 28.0977 20.982 26.6719C20.982 25.2852 20.1813 24.3672 19.0484 24.3672C17.9059 24.3672 17.1051 25.2852 17.1148 26.6719ZM24.0875 33.9375V17.4531H26.1188V24.3477H27.8375V17.082H29.9078V34.7383H27.8375V26.1055H26.1188V33.9375H24.0875ZM47.5109 26.9258V28.6836H40.4992V34.7188H38.3508V28.6836H31.4172V26.9258H47.5109ZM32.257 24.0352C35.7238 23.5957 38.048 21.7305 38.2043 19.7969H32.9016V18.0781H46.0266V19.7969H40.7238C40.8703 21.7305 43.175 23.5957 46.6711 24.0352L45.8898 25.7344C42.882 25.3047 40.5383 23.9277 39.4641 22.0234C38.3801 23.9277 36.0559 25.3047 33.0773 25.7344L32.257 24.0352ZM53.6102 21.7109C53.6199 24.5625 54.5965 27.5312 56.9891 29.0352L55.7977 30.6953C54.2059 29.7383 53.1707 28.0977 52.5848 26.1738C51.95 28.293 50.8172 30.0898 49.157 31.1055L47.8094 29.4844C50.3777 27.9316 51.5105 24.8164 51.5203 21.8086V18.6445H53.6102V21.7109ZM55.0945 24.9531V23.1562H57.6141V17.3945H59.6648V33.8789H57.6141V24.9531H55.0945ZM61.2469 34.7383V17.082H63.3367V34.7383H61.2469ZM80.9203 30.8125V32.5898H64.7875V30.8125H68.518V26.3496C67.1117 25.5391 66.2621 24.2695 66.2719 22.707C66.2621 19.8945 69.016 18.0391 72.8148 18.0391C76.6332 18.0391 79.4066 19.8945 79.3969 22.707C79.4066 24.25 78.5766 25.4902 77.2094 26.3008V30.8125H80.9203ZM68.4008 22.707C68.391 24.5137 70.1781 25.666 72.8148 25.6562C75.4418 25.666 77.268 24.5137 77.268 22.707C77.268 20.8711 75.4418 19.748 72.8148 19.7578C70.1781 19.748 68.391 20.8711 68.4008 22.707ZM70.6664 30.8125H75.0023V27.1309C74.3285 27.2773 73.5961 27.3555 72.8148 27.3555C72.0531 27.3555 71.3305 27.2773 70.6664 27.1406V30.8125Z",
    fill: "#0B8E70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqImg);
export default __webpack_public_path__ + "static/media/reqImg.e16187fcf3399b8dc669f319cf5b6eb1.svg";
export { ForwardRef as ReactComponent };